const config = {
  baseApi: process.env.REACT_APP_BASE_URL || "https://devapiv2.beyousocial.app/api/v1",
};

export default config;
